import { BaseText, Button, Meta, theme, Title } from 'aimo-ui';
import VehicleAvatar from 'components/common/VehicleAvatar';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useVehicleStore } from 'stores/vehicleStore';
import { StyledWrapper } from 'styles/ContainerStyles';
import { useUiStore } from 'stores/uiStore';

const UnsavedEditVehicleConfirm: React.FC = () => {
  const { t } = useTranslation();
  const {
    setIsDiscarded,
    vehicleData: selectedVehicle,
    setVehicleSaved,
  } = useVehicleStore((state) => state);
  const handleDiscard = () => {
    useUiStore.getState().setSheetModal('');
    setIsDiscarded(true);
  };

  const handleUpdateVehicle = async () => {
    useUiStore.getState().setSheetModal('');
    setVehicleSaved(true);
  };

  return (
    <StyledWrapper mb={0}>
      <StyledWrapper mb={20}>
        <VehicleAvatar
          color={selectedVehicle?.appSettings?.color}
          icon={selectedVehicle?.appSettings?.icon}
          size="xxl"
        />
      </StyledWrapper>
      <StyledWrapper mb={6}>
        <Title center testID="remove-vehicle-license">
          {selectedVehicle?.licensePlate?.plateText}
        </Title>
      </StyledWrapper>
      <StyledWrapper mb={0}>
        <BaseText
          center
          testID="remove-vehicle-name"
          color={theme.colors.gray300}>
          {selectedVehicle?.name}
        </BaseText>
      </StyledWrapper>
      <StyledWrapper mb={60}>
        <Meta color={theme.colors.gray300} testID="remove-vehicle-confirm-text">
          {t('vehicle.unsavedChanges.confirmText')}
        </Meta>
      </StyledWrapper>
      <StyledWrapper mb={20}>
        <Button
          testID="edit-vehicle-confirm"
          size="l"
          buttonType="secondary"
          text={t('button.saveChanges')}
          onPress={handleUpdateVehicle}
        />
      </StyledWrapper>
      <StyledWrapper mb={0}>
        <Button
          testID="edit-vehicle-discard"
          size="l"
          buttonType="tertiary"
          text={t('button.discard')}
          onPress={handleDiscard}
        />
      </StyledWrapper>
    </StyledWrapper>
  );
};

export default UnsavedEditVehicleConfirm;
